import axios from "axios";

export const getParametriApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/parametro/${filtri}`);
}

export const getParametroByIdApi = (id) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/parametro/${id}`);
}

export const aggiornaParametroApi = (id, parametro) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/parametro/${id}`, parametro);
}